export enum FeeFieldType {
  YesNo = "YesNo",
  OpenText = "OpenText",
  Numeric = "Numeric",
  Currency = "Currency",
  Percentage = "Percentage",
  Dropdown = "Dropdown",
}
